export const DATE_FORMAT_DISPLAY = "yyyy-MM-dd";
export const DATE_FORMAT_ISO = "yyyy-MM-dd"; //Some areas in the code need specifically the sortable date format
export const DATETIME_FORMAT_DISPLAY = "yyyy-MM-dd HH:mm a";